import momentTz from 'moment-timezone';

export const formatDate = (date, timeZone, format="DD MMM YYYY") => momentTz.tz(date, timeZone).format(format);

export const STRIPR_WARNING_MSG = "Please add the country details for the customer";

export const isSuperAdmin = (token)=>{
    let isSuperAdmin = false;
    try{
        if(token){
            const tokenData = JSON.parse(atob(token.split('.')[1]));
            if(tokenData.role === "SUPER_ADMIN"){
                isSuperAdmin = true;
            }
        }
    }catch(e){
        console.log("error parsing token",e);
        isSuperAdmin = false;
    }
    
    return isSuperAdmin;
}